module.exports = __webpack_public_path__ + "static/media/icade.c3378ac6.png";